import { render, staticRenderFns } from "./NurseryOverview.vue?vue&type=template&id=72a9d41e&scoped=true"
import script from "./NurseryOverview.vue?vue&type=script&lang=js"
export * from "./NurseryOverview.vue?vue&type=script&lang=js"
import style0 from "./NurseryOverview.vue?vue&type=style&index=0&id=72a9d41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9d41e",
  null
  
)

export default component.exports